import React from "react";
import "./QuestionMarkIcon.scss";

const QuestionMarkIcon = () => {
  return <div className="question-mark-icon">?</div>;
};

export default QuestionMarkIcon;
